module.exports = __webpack_public_path__ + "img/the-city-we-became.3a5288be.png";